import styled, {
  css,
} from 'styled-components';
import ContentEditable from 'react-contenteditable';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Empty = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  padding: '10px',
})`
  color: #a7a0a0;
  font-size: 14px;
  font-style: italic;
  font-weight: 700;
  line-height: 20px;
  cursor: default;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);

  ${props => props.isEmpty && `
    cursor: default;
    font-style: italic;
  `};
`;

export const Workout = styled(Flex).attrs({
  width: '100%',
  align: 'center',
})`
  cursor: pointer;
  opacity: ${props => (props.isDragging ? 0.5 : 1)};
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  color: ${props => (props.active ? 'white' : '#797979')};
  background-color: ${props => (props.active ? props.theme.colors.baseBanner : 'inherit')};

  svg {
    color: ${props => (props.active ? 'white' : props.theme.colors.primary)};
  }
`;

const workoutName = css`
  margin: 0;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const WorkoutName = styled.div`
  ${workoutName}
`;

export const EditableWorkoutName = styled(ContentEditable)`
  ${workoutName}
`;

export const Sort = styled(Flex).attrs({
  flex: '0 0 26px',
  align: 'center',
  justify: 'center',
})`
  width: 26px;
  height: 30px;
  opacity: 0.8;
  cursor: move;
  text-align: center;

  svg {
    margin-left: 8px;
  }

  &:hover {
    opacity: 1;
  }

  @media print {
    display: none;
  }
`;

export const ContextMenu = styled(SVG.ContextMenu).attrs(
  props => ({
    width: 20,
    height: 30,
    stroke: props.active ? 'white' : props.theme.colors.primary,
    transform: 'scale(1.6)',
  }),
)``;
